import { useState } from "react";
import { SIMULATOR_BASE_URL } from "../api";
import { useApp } from "../store";

/**
 * Drives the provider simulator from inside the app, so the inbound half of the product can be shown
 * without a second window or curl. Hidden unless VITE_SIMULATOR_BASE_URL is set, and it only ever talks
 * to the simulator's control API - never to the backend.
 */
export function DemoPanel(): JSX.Element | null {
  const { numbers } = useApp();
  const [status, setStatus] = useState<string | null>(null);
  const [from, setFrom] = useState("+4570203040");
  const [text, setText] = useState("Hi, is this the support line?");
  const active = numbers.filter((number) => number.state === "ACTIVE");

  if (!SIMULATOR_BASE_URL || active.length === 0) {
    return null;
  }
  const target = active[0].e164;

  async function control(path: string, body: unknown): Promise<void> {
    setStatus("...");
    try {
      const response = await fetch(`${SIMULATOR_BASE_URL}${path}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });
      setStatus(response.ok ? "sent" : `failed (${response.status})`);
    } catch (error) {
      setStatus(error instanceof Error ? error.message : "failed");
    }
  }

  return (
    <div className="demo-panel">
      <div className="section-label">
        Simulate inbound traffic to {target} {status ? `\u00B7 ${status}` : ""}
      </div>
      <div className="row">
        <input value={from} onChange={(event) => setFrom(event.target.value)} aria-label="From" />
        <input value={text} onChange={(event) => setText(event.target.value)} aria-label="Text" />
      </div>
      <div className="row" style={{ marginTop: 6 }}>
        <button
          type="button"
          onClick={() => control("/control/telnyx/inbound-message", { from, to: target, text })}
        >
          Send SMS
        </button>
        <button type="button" onClick={() => control("/control/telnyx/inbound-call", { from, to: target })}>
          Ring me
        </button>
      </div>
    </div>
  );
}
